import { render, staticRenderFns } from "./ProductDetalis.vue?vue&type=template&id=512af060&scoped=true&"
import script from "./ProductDetalis.vue?vue&type=script&lang=js&"
export * from "./ProductDetalis.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetalis.vue?vue&type=style&index=0&id=512af060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512af060",
  null
  
)

export default component.exports